// extracted by mini-css-extract-plugin
module.exports = {"desktop":"vertical-tabs_desktop__s_8f7","tablet":"vertical-tabs_tablet__PL4Qn"};